import React from 'react';
import { FormattedMessage } from 'react-intl';

import PopOver from '@bibliocommons/deprecated-base-accessibility-pop-over';
import { Info } from '@bibliocommons/base-icons';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import './BroadenSearchInfoPopOver.scss';

function renderContent() {
  return (
    <div className="pop-over-content">
      <div className="prompt-heading-block">
        <FormattedMessage id="broaden_search_info_heading" tagName="h4" />
      </div>
      <FormattedMessage id="broaden_search_info_desc" />
    </div>
  );
}

function renderTriggerContent() {
  return (
    <div>
      <ScreenReaderMessage>
        <FormattedMessage id="ada_broaden_search_info" />
      </ScreenReaderMessage>
      <div className="pop-over-trigger">
        <Info />
        <span aria-hidden="true">
          <FormattedMessage id="more_details" />
        </span>
      </div>
    </div>
  );
}

export default function BroadenSearchInfoPopOver() {
  return (
    <span className="cp-broaden-search-info-warning">
      <PopOver
        href="#broaden-search-info-warning"
        triggerKey="broaden-search-info-warning"
        dataKey="broaden-search-info-warning-pop-over"
        triggerContent={renderTriggerContent()}
      >
        {renderContent()}
      </PopOver>
    </span>
  );
}
